/* ============================================================
   ILUMEISTER — LUXURY THEME JS
   Loader → Lenis → GSAP → Header → Cursor → Section reveals
   ============================================================ */

(function () {
  'use strict';

  /* ── Credit protection ── */
  (function guardCredit() {
    const ID = 'sc-studio-credit';
    function rebuild() {
      let el = document.getElementById(ID);
      if (!el) {
        el = document.createElement('div');
        el.id = ID;
        el.innerHTML = 'Designed &amp; Powered by <a href="https://www.smartcody.tech" target="_blank" rel="noopener">SmartCody Studio</a>';
        document.body.appendChild(el);
      }
      el.style.cssText = '';
    }
    rebuild();
    new MutationObserver(rebuild).observe(document.body, { childList: true, subtree: true });
    setInterval(rebuild, 3000);
  })();

  /* ── Loader ── */
  const loader      = document.getElementById('lux-loader');
  const loaderFill  = document.getElementById('lux-loader-fill');
  const loaderCount = document.getElementById('lux-loader-count');

  if (loader && loaderFill && loaderCount) {
    let count = 0;
    const countInt = setInterval(() => {
      count = Math.min(count + Math.floor(Math.random() * 8) + 3, 100);
      loaderCount.textContent = count;
      loaderFill.style.width = count + '%';
      if (count >= 100) {
        clearInterval(countInt);
        setTimeout(() => {
          document.body.classList.add('loader-hidden');
          setTimeout(() => {
            loader.style.display = 'none';
            initLuxury();
          }, 900);
        }, 300);
      }
    }, 40);
  } else {
    initLuxury();
  }

  /* ── Main luxury init (runs after loader exits) ── */
  function initLuxury() {
    if (typeof gsap === 'undefined' || typeof Lenis === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    /* ── Lenis smooth scroll ── */
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    gsap.ticker.add((t) => lenis.raf(t * 1000));
    gsap.ticker.lagSmoothing(0);
    lenis.on('scroll', ScrollTrigger.update);

    /* ── Header scroll state ── */
    const header = document.getElementById('js-site-header');
    if (header) {
      lenis.on('scroll', ({ scroll }) => {
        header.classList.toggle('scrolled', scroll > 60);
      });
    }

    /* ── Hamburger / mobile menu ── */
    const hamburger = document.getElementById('hamburger');
    const mobMenu   = document.getElementById('mob-menu');
    const mobClose  = document.getElementById('mob-close');

    function openMenu() {
      mobMenu.classList.add('open');
      mobMenu.setAttribute('aria-hidden', 'false');
      hamburger && hamburger.setAttribute('aria-expanded', 'true');
      lenis.stop();
    }
    function closeMenu() {
      mobMenu.classList.remove('open');
      mobMenu.setAttribute('aria-hidden', 'true');
      hamburger && hamburger.setAttribute('aria-expanded', 'false');
      lenis.start();
    }

    if (hamburger && mobMenu) {
      hamburger.addEventListener('click', openMenu);
      mobClose && mobClose.addEventListener('click', closeMenu);
      mobMenu.addEventListener('click', (e) => {
        if (e.target === mobMenu) closeMenu();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeMenu();
      });
    }

    /* ── Custom cursor ── */
    document.documentElement.classList.add('js-cursor');
    const dot  = document.getElementById('cur-dot');
    const ring = document.getElementById('cur-ring');
    if (dot && ring && window.matchMedia('(hover:hover)').matches) {
      const dotX  = gsap.quickTo(dot,  'x', { duration: 0.05, ease: 'power3.out' });
      const dotY  = gsap.quickTo(dot,  'y', { duration: 0.05, ease: 'power3.out' });
      const ringX = gsap.quickTo(ring, 'x', { duration: 0.22, ease: 'power3.out' });
      const ringY = gsap.quickTo(ring, 'y', { duration: 0.22, ease: 'power3.out' });

      let cursorVisible = false;
      document.addEventListener('mousemove', (e) => {
        if (!cursorVisible) {
          gsap.set([dot, ring], { x: e.clientX, y: e.clientY });
          gsap.to([dot, ring], { opacity: 1, duration: 0.4 });
          cursorVisible = true;
        }
        dotX(e.clientX);
        dotY(e.clientY);
        ringX(e.clientX);
        ringY(e.clientY);
      });

      document.addEventListener('mouseleave', () => {
        gsap.to([dot, ring], { opacity: 0, duration: 0.3 });
        cursorVisible = false;
      });

      document.querySelectorAll('a,button,[data-cursor-grow]').forEach(el => {
        el.addEventListener('mouseenter', () => {
          gsap.to(ring, { scale: 1.7, borderColor: 'rgba(212,175,55,0.25)', duration: 0.3 });
          gsap.to(dot,  { scale: 0.4, duration: 0.3 });
        });
        el.addEventListener('mouseleave', () => {
          gsap.to(ring, { scale: 1, borderColor: 'rgba(212,175,55,0.55)', duration: 0.3 });
          gsap.to(dot,  { scale: 1, duration: 0.3 });
        });
      });
    }

    /* ── Generic reveal animations ── */
    gsap.utils.toArray('.reveal').forEach(el => {
      gsap.fromTo(el,
        { opacity: 0, y: 40 },
        {
          opacity: 1, y: 0, duration: 1.1, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' }
        }
      );
    });

    gsap.utils.toArray('.reveal-left').forEach(el => {
      gsap.fromTo(el,
        { opacity: 0, x: -50 },
        {
          opacity: 1, x: 0, duration: 1.1, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 85%', toggleActions: 'play none none none' }
        }
      );
    });

    gsap.utils.toArray('.reveal-right').forEach(el => {
      gsap.fromTo(el,
        { opacity: 0, x: 50 },
        {
          opacity: 1, x: 0, duration: 1.1, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 85%', toggleActions: 'play none none none' }
        }
      );
    });

    gsap.utils.toArray('.reveal-stagger').forEach(parent => {
      const items = parent.querySelectorAll(':scope > *');
      gsap.fromTo(items,
        { opacity: 0, y: 32 },
        {
          opacity: 1, y: 0,
          duration: 0.9, ease: 'power3.out',
          stagger: 0.12,
          scrollTrigger: { trigger: parent, start: 'top 85%', toggleActions: 'play none none none' }
        }
      );
    });

    /* ── Parallax sections ── */
    gsap.utils.toArray('[data-parallax]').forEach(el => {
      const speed = parseFloat(el.dataset.parallax) || 0.3;
      gsap.to(el, {
        yPercent: speed * -60,
        ease: 'none',
        scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    });

    /* ── Clip-path wipe reveals ── */
    gsap.utils.toArray('.wipe-reveal').forEach(el => {
      gsap.fromTo(el,
        { 'clip-path': 'inset(100% 0 0 0)' },
        {
          'clip-path': 'inset(0% 0 0 0)',
          duration: 1.2, ease: 'power4.out',
          scrollTrigger: { trigger: el, start: 'top 90%', toggleActions: 'play none none none' }
        }
      );
    });

    /* ── Gold line grow ── */
    gsap.utils.toArray('.gold-line').forEach(el => {
      gsap.fromTo(el, { scaleX: 0 }, {
        scaleX: 1, duration: 1.4, ease: 'power3.inOut', transformOrigin: 'left',
        scrollTrigger: { trigger: el, start: 'top 90%' }
      });
    });

    /* ── Counter animation ── */
    document.querySelectorAll('[data-count]').forEach(el => {
      const target = parseInt(el.dataset.count);
      ScrollTrigger.create({
        trigger: el,
        start: 'top 80%',
        once: true,
        onEnter: () => {
          gsap.fromTo({ v: 0 }, { v: target, duration: 2, ease: 'power2.out',
            onUpdate: function () { el.textContent = Math.round(this.targets()[0].v); }
          });
        }
      });
    });

    /* ── Marquee ── */
    initMarquee();
  }

  /* ── Marquee clone (infinite scroll text) ── */
  function initMarquee() {
    document.querySelectorAll('.marquee-track').forEach(track => {
      const items = Array.from(track.children);
      items.forEach(item => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    });
  }

  /* ── Theme toggle ── */
  window.toggleTheme = function () {
    const html  = document.documentElement;
    const label = document.getElementById('themeLabel');
    const isDark = html.getAttribute('data-theme') === 'dark';
    html.setAttribute('data-theme', isDark ? 'light' : 'dark');
    if (label) label.textContent = isDark ? 'Tume' : 'Hele';
    localStorage.setItem('ilumeister-theme', isDark ? 'light' : 'dark');
  };

  /* ── Apply saved theme on load ── */
  (function applyTheme() {
    const saved = localStorage.getItem('ilumeister-theme');
    if (saved) {
      document.documentElement.setAttribute('data-theme', saved);
      const label = document.getElementById('themeLabel');
      if (label) label.textContent = saved === 'dark' ? 'Hele' : 'Tume';
    }
  })();

})();
